import React from 'react';
import { DollarSign, ChevronRight, Trophy } from 'lucide-react';

interface SellerData {
    user_id: string;
    full_name: string;
    total_revenue: number;
    total_sales: number;
}

interface TopSellersListProps {
    data: SellerData[];
    loading: boolean;
}

export const TopSellersList: React.FC<TopSellersListProps> = ({ data, loading }) => {
    return (
        <div style={{
            background: 'var(--glass-bg)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            border: 'var(--glass-border)',
            borderRadius: 'var(--radius)',
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflow: 'hidden'
        }}>
            <h3 style={{
                fontSize: '18px',
                fontWeight: 600,
                color: '#fff',
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
            }}>
                <div style={{ background: 'rgba(234, 179, 8, 0.1)', padding: '6px', borderRadius: '8px', display: 'flex' }}>
                    <Trophy size={18} color="#eab308" />
                </div>
                Top Vendedores
            </h3>

            {loading ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {[1, 2, 3].map(i => (
                        <div key={i} className="shimmer-loading" style={{ height: '80px', borderRadius: '12px', width: '100%' }}></div>
                    ))}
                </div>
            ) : data && data.length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', overflowY: 'auto', paddingRight: '4px' }} className="custom-scrollbar">
                    {data.map((seller, index) => (
                        <div key={seller.user_id || index} style={{
                            background: 'rgba(255, 255, 255, 0.02)',
                            border: '1px solid rgba(255, 255, 255, 0.04)',
                            borderRadius: '12px',
                            padding: '16px',
                            transition: 'all 0.2s ease',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                            className="bot-revenue-item hover:bg-white/[0.04]"
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <div style={{
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '8px',
                                    background: index === 0 ? 'rgba(234, 179, 8, 0.2)' : index === 1 ? 'rgba(156, 163, 175, 0.2)' : index === 2 ? 'rgba(180, 83, 9, 0.2)' : 'rgba(255, 255, 255, 0.05)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold',
                                    color: index === 0 ? '#fde047' : index === 1 ? '#e5e7eb' : index === 2 ? '#fcd34d' : '#9ca3af',
                                    fontSize: '14px'
                                }}>
                                    {index + 1}º
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ fontSize: '15px', fontWeight: 600, color: '#f4f4f5' }}>
                                        {seller.full_name}
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#a1a1aa' }}>
                                        {seller.total_sales} vendas
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{ fontSize: '16px', fontWeight: 700, color: '#22c55e' }}>
                                    R$ {seller.total_revenue.toFixed(2)}
                                </div>
                                <ChevronRight size={16} color="#666" />
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '32px', textAlign: 'center' }}>
                    <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'rgba(255,255,255,0.03)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
                        <Trophy size={24} color="#555" />
                    </div>
                    <div style={{ color: '#a1a1aa', fontSize: '15px', fontWeight: 500, marginBottom: '8px' }}>Nenhum vendedor encontrado</div>
                    <div style={{ color: '#52525b', fontSize: '13px', maxWidth: '80%' }}>Quando os produtores começarem a vender, o ranking aparecerá aqui.</div>
                </div>
            )}
        </div>
    );
};
